import PendoTooltip from '../../directives/tooltip/pendo-tooltip.js';
import { keyCodes } from '../../utils/utils.js';

var script = {
  name: 'SliderDot',
  directives: {
    PendoTooltip
  },
  props: {
    value: {
      type: null,
      required: true
    },
    disabled: {
      type: Boolean
    },
    formatTooltip: {
      type: Function
    },
    max: {
      type: Number
    },
    min: {
      type: Number
    },
    precision: {
      type: Number
    },
    step: {
      type: Number
    },
    showStops: {
      type: Boolean
    },
    showTooltip: {
      type: Boolean
    },
    sliderSize: {
      type: Number
    },
    vertical: {
      type: Boolean
    },
    type: {
      type: String
    }
  },
  data() {
    return {
      isTooltipVisible: false,
      isHovering: false,
      isDragging: false,
      isClick: false,
      startX: 0,
      currentX: 0,
      startY: 0,
      currentY: 0,
      startPosition: 0,
      newPosition: null,
      oldValue: this.value
    };
  },
  computed: {
    currentPosition() {
      return `${(this.value - this.min) / (this.max - this.min) * 100}%`;
    },
    lengthPerStep() {
      return 100 / ((this.max - this.min) / this.step);
    },
    tooltipContent() {
      if (!this.showTooltip || this.value == null) {
        return false;
      }
      if (this.formatTooltip instanceof Function) {
        return this.formatTooltip(this.value).toString();
      }
      return parseFloat(this.value.toFixed(this.precision)).toString();
    },
    wrapperStyle() {
      return this.vertical ? {
        bottom: this.currentPosition
      } : {
        left: this.currentPosition
      };
    },
    isBarType() {
      return this.type === 'bar';
    }
  },
  methods: {
    onMouseenter() {
      this.isHovering = true;
      this.isTooltipVisible = true;
    },
    onMouseleave() {
      this.isHovering = false;
      this.isTooltipVisible = false;
    },
    onMousedown(event) {
      if (this.disabled) {
        return;
      }
      event.preventDefault();
      window.addEventListener('mouseup', this.onDragEnd);
      window.addEventListener('mouseleave', this.onDragEnd);
      window.addEventListener('mousemove', this.onDrag);
      this.onDragStart(event);
    },
    onKeydown(event) {
      if (this.disabled) {
        return;
      }
      const {
        end,
        home,
        left,
        up,
        right,
        down
      } = keyCodes;
      if ([end, home, left, up, right, down].includes(event.keyCode)) {
        event.preventDefault();
        this.startPosition = parseFloat(this.currentPosition);
        switch (event.keyCode) {
          case up:
          case right:
            this.newPosition = this.startPosition + this.lengthPerStep;
            break;
          case down:
          case left:
            this.newPosition = this.startPosition - this.lengthPerStep;
            break;
          case home:
            this.newPosition = 0;
            break;
          case end:
            this.newPosition = 100;
            break;
        }
        this.setPosition('keydown', this.newPosition);
      }
    },
    onDragStart(event) {
      this.isDragging = true;
      this.isClick = true;
      if (this.vertical) {
        this.startY = event.clientY;
      } else {
        this.startX = event.clientX;
      }
      this.startPosition = parseFloat(this.currentPosition);
      this.newPosition = this.startPosition;
      this.$emit('drag-start', this.startPosition);
    },
    onDrag(event) {
      if (this.isDragging) {
        this.isClick = false;
        this.isTooltipVisible = true;
        let diff = 0;
        if (this.vertical) {
          this.currentY = event.clientY;
          diff = (this.startY - this.currentY) / this.sliderSize * 100;
        } else {
          this.currentX = event.clientX;
          diff = (this.currentX - this.startX) / this.sliderSize * 100;
        }
        this.newPosition = this.startPosition + diff;
        this.setPosition('drag', this.newPosition);
      }
    },
    onDragEnd() {
      if (this.isDragging) {
        requestAnimationFrame(() => {
          this.isDragging = false;
          this.isTooltipVisible = false;
          if (!this.isClick) {
            this.setPosition('drag-end', this.newPosition);
          } else {
            this.$emit('drag-cancel');
          }
        });
        window.removeEventListener('mousemove', this.onDrag);
        window.removeEventListener('mouseup', this.onDragEnd);
        window.removeEventListener('mouseleave', this.onDragEnd);
      }
    },
    setPosition(event, newPosition) {
      if (newPosition === null || isNaN(newPosition)) {
        return;
      }
      if (newPosition < 0) {
        newPosition = 0;
      } else if (newPosition > 100) {
        newPosition = 100;
      }
      let steps = newPosition / this.lengthPerStep;
      let value = steps * this.lengthPerStep * (this.max - this.min) * 0.01 + this.min;
      if (this.showStops) {
        steps = Math.round(newPosition / this.lengthPerStep);
        value = steps * this.lengthPerStep * (this.max - this.min) * 0.01 + this.min;
        value = parseFloat(value.toFixed(this.precision));
      }
      this.$emit(event, value);
      if (!this.isDragging && this.value !== this.oldValue) {
        this.oldValue = this.value;
      }
    }
  }
};

export { script as default };
//# sourceMappingURL=dot.vue2.js.map
